import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExamplePieWidgetComponent } from './example-pie-widget.component';
import {DxPieChartModule} from 'devextreme-angular';



@NgModule({
  declarations: [ExamplePieWidgetComponent],
    imports: [
        CommonModule,
        DxPieChartModule
    ],
  exports: [ExamplePieWidgetComponent]
})
export class ExamplePieWidgetModule { }
